import { ROUTE_ACTION_PLAN } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './action-plan.page';

export const routeActionPlan: RouteObject = {
  path: ROUTE_ACTION_PLAN,
  Component: Page,
  loader: setTitleFromLoader('Action Plan'),
};
